/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React from 'react';
import CubbyContext from './CubbyContext';

const withCubbyContext = WrappedComponent => {
  class WithCubbyContext extends React.Component {
    render() {
      return (
        <CubbyContext.Consumer>
          {value => <WrappedComponent {...this.props} cubbyContext={value} />}
        </CubbyContext.Consumer>
      );
    }
  }
  return WithCubbyContext;
};

export default withCubbyContext;
